import CurrencyPair from './CurrencyPair';

export default CurrencyPair;
